import { configureStore } from "@reduxjs/toolkit";
import loggedInReducer from './loggedIn';
import modalWindowSlice from './modalWindowSlice';

export const store = configureStore({
    reducer: {
        loggedIn: loggedInReducer,
        modal: modalWindowSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;